import { render, staticRenderFns } from "./Run.vue?vue&type=template&id=3bb882d0&scoped=true&"
import script from "./Run.vue?vue&type=script&lang=js&"
export * from "./Run.vue?vue&type=script&lang=js&"
import style0 from "./Run.vue?vue&type=style&index=0&id=3bb882d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb882d0",
  null
  
)

export default component.exports